






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BigCommerce extends Vue {
  @Prop({ default: '21' }) readonly width?: string;
  @Prop({ default: '21' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
